import React from "react";

import Divider from "@mui/material/Divider";

import MDBox from "../md-box";
import MDTypography from "../md-typography";
import { GridComponent, SkeletonComponent } from "@/lib/components";

interface DetailsSkeletonComponentProps {
  items?: number;
  showActions?: boolean;
}

export const DetailsSkeletonComponent = ({
  items = 4,
  showActions = true,
}: DetailsSkeletonComponentProps) => {
  return (
    <GridComponent container spacing={2} minHeight={415}>
      <GridComponent
        size={{
          xs: 12,
        }}
      >
        <MDTypography variant="h3" fontWeight="bold">
          <SkeletonComponent width={"50%"} />
        </MDTypography>
        <Divider />
      </GridComponent>
      {Array.from({ length: items }).map((_, index) => (
        <GridComponent
          size={{
            xs: 12,
            sm: 6,
          }}
          key={`details_skeleton_item_${index}`}
        >
          <MDTypography variant="body2" fontWeight="bold" marginBottom="1.5ch">
            <SkeletonComponent />
          </MDTypography>
          <MDTypography variant="body2">
            <SkeletonComponent />
          </MDTypography>
        </GridComponent>
      ))}
      {showActions && (
        <GridComponent
          size={{
            xs: 12,
          }}
        >
          <MDBox display="flex" gap={2} justifyContent="flex-end">
            <SkeletonComponent variant="rectangular" width={"30%"} height={40} />
          </MDBox>
        </GridComponent>
      )}
    </GridComponent>
  );
};
